import { Helmet } from "react-helmet";
import { useStoreContext } from "../../contexts/StoreProvider";
import Layout from "../../components/Layout";
import styles from "./index.module.scss";
import Login from "../Login";

const NoAccess = () => {
  const {
    state: { user },
  } = useStoreContext();

  return user ? (
    <Layout>
      <Helmet>
        <title>No Access</title>
      </Helmet>
      <div className={styles.container}>
        You do not have permissions to access this page
      </div>
    </Layout>
  ) : (
    <Login />
  );
};

export default NoAccess;
